import * as e from "react";
import { jsx as t } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-context@1.2.0_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-context/dist/index.mjs
function n(n, i = []) {
	let a = [];
	function o(r, i) {
		let o = e.createContext(i);
		o.displayName = r + "Context";
		let s = a.length;
		a = [...a, i];
		let c = (r) => {
			let { scope: i, children: a, ...c } = r, l = i?.[n]?.[s] || o, u = e.useMemo(() => c, Object.values(c));
			return /* @__PURE__ */ t(l.Provider, {
				value: u,
				children: a
			});
		};
		c.displayName = r + "Provider";
		function l(t, a, c = {}) {
			let { optional: l = !1 } = c, u = a?.[n]?.[s] || o, d = e.useContext(u);
			if (d) return d;
			if (i !== void 0) return i;
			if (!l) throw Error(`\`${t}\` must be used within \`${r}\``);
		}
		return [c, l];
	}
	let s = () => {
		let t = a.map((t) => e.createContext(t));
		return function(r) {
			let i = r?.[n] || t;
			return e.useMemo(() => ({ [`__scope${n}`]: {
				...r,
				[n]: i
			} }), [r, i]);
		};
	};
	return s.scopeName = n, [o, r(s, ...i)];
}
function r(...t) {
	let n = t[0];
	if (t.length === 1) return n;
	let r = () => {
		let r = t.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return function(t) {
			let i = r.reduce((e, { useScope: n, scopeName: r }) => {
				let i = n(t)[`__scope${r}`];
				return {
					...e,
					...i
				};
			}, {});
			return e.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		};
	};
	return r.scopeName = n.scopeName, r;
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+primitive@1.1.6/node_modules/@radix-ui/primitive/dist/index.mjs
var i = Object.defineProperty, a = (e, t) => i(e, "name", {
	value: t,
	configurable: !0
}), o = !!(typeof window < "u" && window.document && window.document.createElement);
function s(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ a(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
a(s, "composeEventHandlers");
function c(e) {
	if (!o) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
a(c, "getOwnerWindow");
function l(e) {
	if (!o) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
a(l, "getOwnerDocument");
function u(e, t = !1) {
	let { activeElement: n } = l(e);
	if (!n?.nodeName) return null;
	if (d(n) && n.contentDocument) return u(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = l(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
a(u, "getActiveElement");
function d(e) {
	return e.tagName === "IFRAME";
}
a(d, "isFrame");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.2_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var f = globalThis?.document ? e.useLayoutEffect : () => {}, p = e.useEffectEvent, m = e.useInsertionEffect;
function h(t) {
	if (typeof p == "function") return p(t);
	let n = e.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof m == "function" ? m(() => {
		n.current = t;
	}) : f(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.4_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var g = Object.defineProperty, _ = (e, t) => g(e, "name", {
	value: t,
	configurable: !0
}), v = e.useInsertionEffect || f;
function y({ prop: t, defaultProp: n, onChange: r = /* @__PURE__ */ _(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = b({
		defaultProp: n,
		onChange: r
	}), c = t !== void 0;
	return [c ? t : a, e.useCallback((e) => {
		if (c) {
			let n = x(e) ? e(t) : e;
			n !== t && s.current?.(n);
		} else o(e);
	}, [
		c,
		t,
		o,
		s
	])];
}
_(y, "useControllableState");
function b({ defaultProp: t, onChange: n }) {
	let [r, i] = e.useState(t), a = e.useRef(r), o = e.useRef(n);
	return v(() => {
		o.current = n;
	}, [n]), e.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
_(b, "useUncontrolledState");
function x(e) {
	return typeof e == "function";
}
_(x, "isFunction");
var S = Symbol("RADIX:SYNC_STATE");
function C(t, n, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = n, l = a !== void 0, u = h(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = e.useReducer((e, n) => {
		if (n.type === S) return {
			...e,
			state: n.state
		};
		let r = t(e, n);
		return l && !Object.is(r.state, e.state) && u(r.state), r;
	}, ...d), m = f.state, g = e.useRef(m);
	e.useEffect(() => {
		g.current !== m && (g.current = m, l || u(m));
	}, [
		m,
		g,
		l
	]);
	let _ = e.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return e.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: S,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [_, p];
}
_(C, "useControllableStateReducer");
//#endregion
export { n as i, f as n, s as r, y as t };

//# sourceMappingURL=dist-By11B3Nf.js.map